import { Box, Typography } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import { useMemo } from "react";

function ProfitLost({ data, isPercent = true }) {
  const profitColor = useMemo(() => {
    if (data?.percent > 0) {
      return "success.main";
    }

    if (data?.percent < 0) {
      return "error.main";
    } else {
      return "text.main";
    }
  }, []);
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={{ xs: "flex-start", md: "center" }}
      textAlign={{ xs: "left", md: "center" }}
    >
      <Typography variant="h6" color="text.main">
        <Typography variant="h6" color={profitColor}>
          <NumberFormats value={data?.profitOrLoss} />{" "}
          <Typography
            component="span"
            variant="subtitle1"
            color="text.secondary"
          >
            {data?.coinName}
          </Typography>
        </Typography>

        {isPercent &&
          <Typography variant="h6" color={profitColor}>
            {data?.percent} %
          </Typography>
        }
      </Typography>
    </Box>
  );
}

export default ProfitLost;
